import { CareSkill } from '../models/employee/care-skill';
import { Employee } from '../models/employee/employee';
import { CenterType } from './center-type.enum';

export interface CompetenceElementaire {
	name: string;
	label: string;
	id: number;
	centerType: CenterType;
}

export const CompetencesElementaires: { [key: string]: CompetenceElementaire } =
	{
		// SSIAD
		INFIRMIER: {
			name: 'INFIRMIER',
			label: 'Infirmier.ère',
			id: 101,
			centerType: CenterType.SSIAD
		},
		AIDESOIGNANT: {
			name: 'AIDESOIGNANT',
			label: 'Aide soignant.te',
			id: 102,
			centerType: CenterType.SSIAD
		},

		// SAAD
		AIDEADOMICILE: {
			name: 'AIDEADOMICILE',
			label: 'Aide à domicile',
			id: 201,
			centerType: CenterType.SAAD
		},

		// SESSAD
		LPC: { name: 'LPC', label: 'LPC', id: 1, centerType: CenterType.SESSAD },
		LSF: { name: 'LSF', label: 'LSF', id: 2, centerType: CenterType.SESSAD },
		PRISE_DE_NOTES: {
			name: 'PRISE_DE_NOTES',
			label: 'Prise de notes',
			id: 3,
			centerType: CenterType.SESSAD
		},
		ORAL: { name: 'ORAL', label: 'Oral', id: 4, centerType: CenterType.SESSAD },

		// SAE
		QUALIFICATION: {
			name: 'QUALIFICATION',
			label: 'Qualification',
			id: 301,
			centerType: CenterType.SAE
		},
		TERRAIN: {
			name: 'TERRAIN',
			label: 'Terrain',
			id: 302,
			centerType: CenterType.SAE
		},
		PRESCRIPTION: {
			name: 'PRESCRIPTION',
			label: 'Prescription',
			id: 303,
			centerType: CenterType.SAE
		}
	};

export function getCompetencesByCenterType(
	centerType: CenterType
): CompetenceElementaire[] {
	return Object.values(CompetencesElementaires).filter(
		(comp) => comp.centerType === centerType
	);
}

export function hasEmployeeSkill(
	employee: Employee,
	careSkill: CareSkill | CompetenceElementaire
): boolean {
	return employee.careSkills.some((skill) => skill.name === careSkill.name);
}

export function isElementarySkill(careSkillName: string): boolean {
	return CompetencesElementaires.hasOwnProperty(careSkillName);
}
